module.exports = __webpack_public_path__ + "static/img/aiqc-defect-holes.579ea6a8.jpg";